import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../encoding/AbstractEncoder.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../modules/SerializersModuleBuilders.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NoOpEncoderClass;
function NoOpEncoder() {
  if (NoOpEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      static b20() {
        NoOpEncoder_instance = null;
        var $this = this.h1s();
        NoOpEncoder_instance = $this;
        $this.a20_1 = EmptySerializersModule();
        return $this;
      }
      d1s() {
        return this.a20_1;
      }
      j1s(value) {
        return Unit_instance;
      }
      k1s() {
        return Unit_instance;
      }
      l1s(value) {
        return Unit_instance;
      }
      m1s(value) {
        return Unit_instance;
      }
      n1s(value) {
        return Unit_instance;
      }
      o1s(value) {
        return Unit_instance;
      }
      p1s(value) {
        return Unit_instance;
      }
      q1s(value) {
        return Unit_instance;
      }
      r1s(value) {
        return Unit_instance;
      }
      s1s(value) {
        return Unit_instance;
      }
      t1s(value) {
        return Unit_instance;
      }
      u1s(enumDescriptor, index) {
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'NoOpEncoder');
    NoOpEncoderClass = $;
  }
  return NoOpEncoderClass;
}
var NoOpEncoder_instance;
function NoOpEncoder_getInstance() {
  if (NoOpEncoder_instance === VOID)
    NoOpEncoder().b20();
  return NoOpEncoder_instance;
}
//region block: exports
export {
  NoOpEncoder_getInstance as NoOpEncoder_getInstance2eh3dcptdd2fa,
};
//endregion

//# sourceMappingURL=NoOpEncoder.mjs.map
